"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegacyModeChanged = exports.EditorBackgroundShapeNames = exports.EditorBackgroundShapes = exports.ExportSizeLabels = exports.ExportSizes = exports.calculateShouldUpsell = exports.UpsellTransforms = exports.PaletteModes = exports.EditorTransforms = exports.WHITE = exports.BLACK = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.sign = sign;

var _omitBy = require("lodash/omitBy");

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isEqual = require("lodash/isEqual");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _sample = require("lodash/sample");

var _sample2 = _interopRequireDefault(_sample);

var _reduce = require("lodash/reduce");

var _reduce2 = _interopRequireDefault(_reduce);

var _localStorage = require("../legacy/helpers/localStorage");

var _localStorage2 = _interopRequireDefault(_localStorage);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("../actions/actions");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLIP_HORIZONTAL = "FLIP_HORIZONTAL";
var FLIP_VERTICAL = "FLIP_VERTICAL";
var ROTATE_CCW = "ROTATE_CCW";
var ROTATE_CW = "ROTATE_CW";
var SET_ROTATION = "SET_ROTATION";
var ICON_COLOR = "ICON_COLOR";
var BACKGROUND_COLOR = "BACKGROUND_COLOR";
var BACKGROUND_SHAPE = "BACKGROUND_SHAPE";
var EDITOR_EXPORT = "EDITOR_EXPORT";
var EXPORT_SIZE = "EXPORT_SIZE";

var PALETTE = "PALETTE";
var PALETTE_MODE = "PALETTE_MODE";

var TRANSPARENT = "transparent";
var BLACK = exports.BLACK = "#000000";
var WHITE = exports.WHITE = "#FFFFFF";

var EditorTransforms = exports.EditorTransforms = {
    FLIP_VERTICAL: FLIP_VERTICAL,
    FLIP_HORIZONTAL: FLIP_HORIZONTAL,
    ROTATE_CCW: ROTATE_CCW,
    ROTATE_CW: ROTATE_CW,
    ICON_COLOR: ICON_COLOR,
    BACKGROUND_COLOR: BACKGROUND_COLOR,
    BACKGROUND_SHAPE: BACKGROUND_SHAPE,
    EXPORT_SIZE: EXPORT_SIZE,
    SET_ROTATION: SET_ROTATION
};

var PersistentTransforms = [EXPORT_SIZE, ICON_COLOR, BACKGROUND_COLOR, BACKGROUND_SHAPE];

var TransformStateKeys = {
    FLIP_VERTICAL: "scaleX",
    FLIP_HORIZONTAL: "scaleY",
    ROTATE_CCW: "rotate",
    ROTATE_CW: "rotate",
    ICON_COLOR: "color",
    BACKGROUND_COLOR: "backgroundColor",
    BACKGROUND_SHAPE: "backgroundShape",
    EXPORT_SIZE: "exportSize"
};

var MODE_PICKER = "MODE_PICKER";
var MODE_PALETTE = "MODE_PALETTE";
var PaletteModes = exports.PaletteModes = {
    MODE_PICKER: MODE_PICKER,
    MODE_PALETTE: MODE_PALETTE
};

var StateKeyTransforms = (0, _reduce2.default)(TransformStateKeys, function (acc, stateKey, transform) {
    acc[stateKey] = transform;
    return acc;
}, {});

var UpsellTransforms = exports.UpsellTransforms = Object.keys(EditorTransforms).filter(function (t) {
    return t == EXPORT_SIZE;
});

var calculateShouldUpsell = exports.calculateShouldUpsell = function calculateShouldUpsell() {
    var changed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return !!changed.filter(function (t) {
        return !UpsellTransforms.includes(StateKeyTransforms[t]);
    }).length;
};

var ExportSizes = exports.ExportSizes = [100, 128, 512, 1200, 3600];

var ExportSizeLabels = exports.ExportSizeLabels = {
    100: "xS",
    128: "S",
    512: "M",
    1200: "L",
    3600: "xL"
};

var RING = "RING";
var CIRCLE = "CIRCLE";
var SQUARE = "SQUARE";
var ROUNDED_RECT = "ROUNDED_RECT";
var NONE = "NONE";

var EditorBackgroundShapes = exports.EditorBackgroundShapes = {
    RING: RING,
    CIRCLE: CIRCLE,
    SQUARE: SQUARE,
    ROUNDED_RECT: ROUNDED_RECT,
    NONE: NONE
};

var EditorBackgroundShapeNames = exports.EditorBackgroundShapeNames = {
    RING: "Ring",
    CIRCLE: "Circle",
    SQUARE: "Square",
    ROUNDED_RECT: "Rounded",
    NONE: "None"
};

var LegacyModeChanged = exports.LegacyModeChanged = [TransformStateKeys.ICON_COLOR];

var initialTransforms = {
    scaleX: 0.69,
    scaleY: 0.69,
    backgroundColor: TRANSPARENT,
    backgroundShape: NONE,
    color: BLACK,
    exportSize: 1200,
    rotate: 0
};

var initialPalette = [BLACK, WHITE, "#EC5D57", "#F38F19", "#F5D327", "#70C041", "#51A7F9", "#B36AE2"];

var maxPaletteLength = 10;

var makeTransformKey = function makeTransformKey(transform) {
    return "editor." + transform;
};
var persistTransform = function persistTransform(transform, data) {
    var transformKey = makeTransformKey(transform);
    _localStorage2.default.setItem(transformKey, JSON.stringify(data));
};
var clearTransform = function clearTransform(transform) {
    var transformKey = makeTransformKey(transform);
    _localStorage2.default.removeItem(transformKey);
};
var loadTransform = function loadTransform(transform) {
    var transformKey = makeTransformKey(transform);
    var data = _localStorage2.default.getItem(transformKey);

    try {
        data = JSON.parse(data);
    } catch (e) {
        console.warn("load error", transformKey, e);
        data = null;
    }

    return data;
};

/**
 * Gets the sign of a number
 *
 * @param {number} r Number to check sign of
 * returns {number} 1 or -1 depending on the sign of the number (or NaN)
 */
function sign(x) {
    return typeof x === "number" ? x ? x < 0 ? -1 : 1 : x === x ? 0 : NaN : NaN;
}

var isPlugin = global._nounConfig && !!global._nounConfig.pluginHost;
var getStoredOrInitialPalette = function getStoredOrInitialPalette() {
    var palette = loadTransform(PALETTE);

    var legacyPaletteKey = "customColorPalette";
    var legacyPalette = _localStorage2.default.getItem(legacyPaletteKey);
    if (!palette && legacyPalette) {
        try {
            legacyPalette = JSON.parse(legacyPalette);
            legacyPalette = legacyPalette.map(function (c) {
                return c.hex;
            });
        } catch (e) {
            console.warn("loading legacy palette failed", legacyPalette);
        }
        persistTransform(PALETTE, legacyPalette);
    }

    if (!palette) {
        palette = initialPalette;
    }

    return palette;
};

var getStoredOrInitialPaletteMode = function getStoredOrInitialPaletteMode() {
    return loadTransform(PALETTE_MODE) || MODE_PALETTE;
};

var loadPersistedState = function loadPersistedState() {
    var loadState = PersistentTransforms.reduce(function (loadState, transform) {
        var stateKey = TransformStateKeys[transform];
        var stored = loadTransform(transform);
        if ((typeof stored === "undefined" ? "undefined" : _typeof(stored)) != undefined && stored != null) {
            loadState[stateKey] = stored;
        }

        return loadState;
    }, {});

    var palette = getStoredOrInitialPalette();
    var paletteMode = getStoredOrInitialPaletteMode();
    var newState = {
        transforms: _extends({}, initialTransforms, loadState),
        palette: palette,
        paletteMode: paletteMode
    };

    newState.initial = (0, _isEqual2.default)(initialTransforms, newState.transforms);
    newState.changed = calculateChanged(initialTransforms, newState.transforms);
    newState.shouldUpsell = calculateShouldUpsell(newState.changed);

    // newState.initial = hasChanged(newState.changed);
    return newState;
};

var calculateChanged = function calculateChanged(initialTransforms, newTransforms) {
    var changed = [];
    Object.keys(initialTransforms).forEach(function (transform) {
        if (newTransforms[transform] != initialTransforms[transform]) {
            changed.push(transform);
        }
    });
    return changed;
};

var hasChanged = function hasChanged(changed) {
    return (0, _isEmpty2.default)(changed);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    if (state == null) {
        state = loadPersistedState();
    }
    var _state = state,
        processing = _state.processing;


    switch (action.type) {
        case "EDITOR_RESET":
            {
                if (action.preserveEdits) {
                    return state;
                }

                PersistentTransforms.forEach(clearTransform);

                return {
                    initial: true,
                    transforms: initialTransforms,
                    palette: getStoredOrInitialPalette(),
                    paletteMode: getStoredOrInitialPaletteMode(),
                    changed: []
                };
            }

        // Render the edited version of the current icon
        // when its SVG loads
        case "FETCH_SVG_DATA_SUCCESS":
            {
                if (!state.svg && action.iconId == state.iconId) {
                    var svg = action.response;
                    action.asyncDispatch(actions.editorRender(svg));
                }
                return state;
            }
        // When an icon is selected, if the svg is already available
        // render out a version for the editor
        case "DOWNLOAD_SET_FLOW_ACTIVE":
            {
                var id = action.icon.id;

                if (id != state.iconId) {
                    var newState = loadPersistedState();

                    if (action.cachedSvg) {
                        action.asyncDispatch(actions.editorRender(action.cachedSvg));
                    }
                    return _extends({}, newState, {
                        iconId: id,
                        svg: null
                    });
                } else {
                    return state;
                }
            }

        case "DOWNLOAD_RESET_FLOW":
            if (action.preserveEdits) {
                return state;
            }

            return loadPersistedState();
        case "EDITOR_TRANSFORM":
            {
                var transform = action.transform,
                    data = action.data;

                if (!EditorTransforms[transform]) {
                    console.error("unknown transform", action);
                    return state;
                }

                var _state2 = state,
                    palette = _state2.palette;
                var _state$transforms = state.transforms,
                    scaleX = _state$transforms.scaleX,
                    scaleY = _state$transforms.scaleY,
                    backgroundColor = _state$transforms.backgroundColor,
                    backgroundShape = _state$transforms.backgroundShape,
                    color = _state$transforms.color,
                    exportSize = _state$transforms.exportSize,
                    rotate = _state$transforms.rotate;


                var changedTransforms = [transform];
                switch (transform) {
                    case FLIP_HORIZONTAL:
                        {
                            scaleX *= -1;
                            break;
                        }
                    case FLIP_VERTICAL:
                        {
                            scaleY *= -1;
                            break;
                        }
                    case ROTATE_CW:
                        {
                            rotate += 15 * sign(scaleX) * sign(scaleY);
                            break;
                        }
                    case ROTATE_CCW:
                        {
                            rotate -= 15 * sign(scaleX) * sign(scaleY);
                            break;
                        }
                    case SET_ROTATION:
                        {
                            rotate = data % 360;
                            break;
                        }
                    case BACKGROUND_COLOR:
                        {
                            backgroundColor = data;
                            if (backgroundShape == NONE && backgroundColor != TRANSPARENT) {
                                backgroundShape = SQUARE;
                                changedTransforms.push(BACKGROUND_SHAPE);
                            }
                            break;
                        }
                    case BACKGROUND_SHAPE:
                        {
                            backgroundShape = data;
                            if (backgroundColor == TRANSPARENT && backgroundShape != NONE) {
                                if (backgroundShape == RING) {
                                    backgroundColor = color;
                                } else {
                                    backgroundColor = (0, _sample2.default)(palette.filter(function (c) {
                                        return c != color;
                                    })) || WHITE;
                                }
                                changedTransforms.push(BACKGROUND_COLOR);
                            }

                            if (backgroundShape == NONE) {
                                backgroundColor = TRANSPARENT;
                                changedTransforms.push(BACKGROUND_COLOR);
                            }
                            break;
                        }
                    case ICON_COLOR:
                        {
                            color = data;
                            break;
                        }
                    case EXPORT_SIZE:
                        {
                            exportSize = data;
                            break;
                        }
                }

                var _newState = _extends({}, state, {
                    transforms: {
                        scaleX: scaleX,
                        scaleY: scaleY,
                        backgroundColor: backgroundColor,
                        backgroundShape: backgroundShape,
                        color: color,
                        exportSize: exportSize,
                        rotate: rotate % 360
                    },
                    initial: false
                });

                changedTransforms.forEach(function (transform) {
                    if (PersistentTransforms.includes(transform)) {
                        var key = TransformStateKeys[transform];
                        var value = _newState.transforms[key];
                        persistTransform(transform, value);
                    }
                });

                var changed = calculateChanged(initialTransforms, _newState.transforms);
                var shouldUpsell = calculateShouldUpsell(changed);
                return _extends({}, _newState, {
                    changed: changed,
                    initial: hasChanged(changed),
                    shouldUpsell: shouldUpsell
                });
            }

        case actionTypes.EDITOR_ADD_COLOR:
            {
                var _state3 = state,
                    _palette = _state3.palette;
                var _color = action.color;

                if (_color != TRANSPARENT && !_palette.includes(_color)) {
                    _palette = _palette.slice();
                    _palette.push(_color);
                    if (_palette.length > maxPaletteLength) {
                        _palette = _palette.slice(1, maxPaletteLength + 1);
                    }
                    persistTransform(PALETTE, _palette);
                }

                return _extends({}, state, {
                    palette: _palette
                });
            }

        case actionTypes.EDITOR_CACHE_SVG:
            {
                var _svg = action.svg;

                return _extends({}, state, {
                    svg: _svg
                });
            }

        case actionTypes.EDITOR_SET_PALETTE_MODE:
            {
                var mode = action.mode;

                persistTransform(PALETTE_MODE, mode);
                return _extends({}, state, {
                    paletteMode: mode
                });
            }

        default:
            return state;
    }
};